import { render } from "./CreateChain.vue?vue&type=template&id=14db28bc"
import script from "./CreateChain.vue?vue&type=script&lang=js"
export * from "./CreateChain.vue?vue&type=script&lang=js"

import "./CreateChain.vue?vue&type=style&index=0&id=14db28bc&lang=css"
script.render = render

export default script